export default {
  container: {
    position: 'fixed',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    padding: '12px 10px',
    width: '386px',
    height: '100px'
  }
}
